import React from "react";

function HeaderIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1385_2362)">
        <rect width="32" height="32" rx="8" fill="#2563EB" />
        <rect width="32" height="32" rx="8" stroke="#E2E8F0" />
      </g>
      <defs>
        <clipPath id="clip0_1385_2362">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HeaderIcon;
